<mat-form-field appearance="outline" class="interval-select">
  <mat-label>{{ 'COMMON.TIME_INTERVAL.TITLE' | translate }}</mat-label>
  <mat-select [ngModel]="selectedInterval" (ngModelChange)="onIntervalKeyChange($event)">
    @for (key of intervalKeys; track key) {
      <mat-option [value]="key">
        {{ 'COMMON.TIME_INTERVAL.' + key | translate }}
        @if (key === 'SUBSCRIPTION_PERIOD' && subscriptionPeriodLabel !== null) {
          <span class="interval-option-detail">({{ subscriptionPeriodLabel }})</span>
        }
        <!-- TODO Fix this hack for showing the initial value... -->
        {{ selectedInterval === key ? '‎' : '' }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
